export default "__VITE_ASSET__o3U1guSv__"